export default __webpack_public_path__ + "d0d42dd94bc4828dbc16d24fef73c2c3.png";